// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__i1fmn","buttons":"PendingPaymentAlert_buttons__1s1AJ"};